import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { LoadScriptsPostAppComponentLoad } from '../classes/load-scripts.class';

declare var gtag: Function;

@Injectable()
export class GoogleAnalyticsEventsService {

  public config: any;
  public google_analytics_data: any;
  constructor(public sessionService: SessionService) {
    this.config = this.sessionService.get('config');
  }

  

  public async emitEvent(event_data) {
    if (!this.config.measurement_id) return;
    event_data['app_type']=this.sessionService.get("device_type_app")? (this.sessionService.get("device_type_app")==1?"ANDROID_HYBRID":"IOS_HYBRID") : "WEBAPP";
    gtag('event',event_data.event_name,event_data);

  }

  public setUserId() {
  }

  // public async checkClientGAEnable() {
  //  await LoadScriptsPostAppComponentLoad.googleAnalytics();
  // }

  public getEmailId() {
    if (this.sessionService.get('appData')) {
      return this.sessionService.get('appData').vendor_details.email ? this.sessionService.get('appData').vendor_details.email : this.sessionService.get('appData').vendor_details.phone_no;
    } else {

      return 'Click';
    }
  }
}
